export interface ComicChapter {
  id: number;
  title: string;
  updatedAt: string;
}

export interface Comic {
  id: number;
  slug: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  description: string;
  rating: number;
  views: number;
  status: string;
  chapters: ComicChapter[];
  tags: string[];
  updatedAt: string;
  createdAt: string;
}

export const comics: Comic[] = [
  {
    id: 1,
    slug: 'wo-de-nu-you-shi-jue-shi-gao-shou',
    title: '我的女友是绝世高手',
    author: '金明洙',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20illustration%20of%20a%20young%20woman%20martial%20artist%20with%20flowing%20dark%20hair%20in%20a%20dynamic%20action%20pose%2C%20soft%20watercolor%20background%20with%20cherry%20blossoms%2C%20warm%20lighting%2C%20manhwa%20art%20style%2C%20clean%20lines%2C%20romantic%20action%20theme&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: 'romance',
    description: '平凡的大学生李浩然某天救下了一个神秘女孩，却发现她竟然是隐退江湖的绝世高手！从此他的生活天翻地覆，各种武林高手纷至沓来，甜蜜又刺激的恋爱故事就此展开。',
    rating: 4.8,
    views: 12500000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 命运的相遇', updatedAt: '2026-08-01' },
      { id: 2, title: '第2话 隐藏的身份', updatedAt: '2026-08-02' },
      { id: 3, title: '第3话 不速之客', updatedAt: '2026-08-03' },
      { id: 4, title: '第4话 初次交手', updatedAt: '2026-08-04' },
      { id: 5, title: '第5话 她的秘密', updatedAt: '2026-08-05' },
    ],
    tags: ['恋爱', '动作', '武侠', '都市'],
    updatedAt: '2026-08-05',
    createdAt: '2025-06-01',
  },
  {
    id: 2,
    slug: 'mo-wang-cheng-wei-le-nv-er',
    title: '魔王成为了女儿',
    author: '朴智恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20Korean%20webtoon%20illustration%20of%20a%20cute%20little%20girl%20with%20tiny%20demon%20horns%20and%20a%20shy%20smile%2C%20surrounded%20by%20magical%20sparkles%2C%20pastel%20warm%20color%20palette%2C%20soft%20manhwa%20art%20style%2C%20fantasy%20family%20theme%2C%20adorable%20expression&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: 'fantasy',
    description: '统治魔界三千年的最强魔王，在一场大战后转生成了人类家庭的小女儿！面对曾经被他欺负过的勇者后代，以及完全不按套路出牌的人类社会，魔王大人的爆笑育儿日常开始了。',
    rating: 4.9,
    views: 18900000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 转生', updatedAt: '2026-07-28' },
      { id: 2, title: '第2话 新家庭', updatedAt: '2026-07-29' },
      { id: 3, title: '第3话 幼儿园大作战', updatedAt: '2026-07-30' },
      { id: 4, title: '第4话 勇者后裔', updatedAt: '2026-07-31' },
    ],
    tags: ['奇幻', '搞笑', '转生', '日常'],
    updatedAt: '2026-07-31',
    createdAt: '2025-08-15',
  },
  {
    id: 3,
    slug: 'an-ying-lie-ren',
    title: '暗影猎人',
    author: '崔胜贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20moody%20Korean%20webtoon%20illustration%20of%20a%20hooded%20hunter%20holding%20a%20glowing%20sword%20in%20a%20shadowy%20alleyway%2C%20dramatic%20lighting%20from%20above%2C%20urban%20fantasy%20setting%2C%20manhwa%20art%20style%20with%20bold%20ink%20lines%2C%20mysterious%20atmosphere&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: 'action',
    description: '在首尔的暗影之下，存在着不为人知的猎魔人组织。高中生金泰亨意外觉醒了猎魔人血脉，从此白天上学、夜晚猎魔。当古老的恶魔势力在都市中苏醒，他必须快速成长，保护所爱之人。',
    rating: 4.7,
    views: 9800000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 觉醒之夜', updatedAt: '2026-08-03' },
      { id: 2, title: '第2话 暗影中的低语', updatedAt: '2026-08-04' },
      { id: 3, title: '第3话 第一个任务', updatedAt: '2026-08-05' },
    ],
    tags: ['动作', '奇幻', '都市', '猎魔'],
    updatedAt: '2026-08-05',
    createdAt: '2025-09-10',
  },
  {
    id: 4,
    slug: 'tian-cai-chu-shi-de-hun-yue',
    title: '天才厨师的婚约',
    author: '李秀雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20charming%20Korean%20webtoon%20illustration%20of%20a%20handsome%20chef%20in%20white%20uniform%20holding%20a%20beautifully%20plated%20dish%2C%20warm%20kitchen%20background%20with%20golden%20lighting%2C%20romantic%20cooking%20theme%2C%20manhwa%20art%20style%2C%20elegant%20food%20presentation&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: 'romance',
    description: '被誉为「料理天才」的林志勋，因为爷爷的一纸婚约，不得不与素未谋面的女孩同居一个月。对方是个完全不会做饭的富家千金，两人的同居生活充满了美食与笑料，也慢慢滋生了真挚的感情。',
    rating: 4.6,
    views: 7600000,
    status: '已完结',
    chapters: [
      { id: 1, title: '第1话 爷爷的遗愿', updatedAt: '2026-06-01' },
      { id: 2, title: '第2话 同居第一天', updatedAt: '2026-06-15' },
      { id: 3, title: '第3话 味蕾的告白', updatedAt: '2026-07-01' },
    ],
    tags: ['恋爱', '美食', '同居', '治愈'],
    updatedAt: '2026-07-01',
    createdAt: '2025-03-20',
  },
  {
    id: 5,
    slug: 'xiao-yuan-jiang-shi-sheng-cun-ji',
    title: '校园丧尸生存记',
    author: '郑多彬',
    cover: 'https://readdy.ai/api/search-image?query=A%20thrilling%20Korean%20webtoon%20illustration%20of%20students%20running%20through%20a%20school%20hallway%20escaping%20zombies%2C%20dynamic%20action%20scene%20with%20dramatic%20perspective%2C%20warm%20orange%20sunset%20light%20through%20windows%2C%20manhwa%20art%20style%2C%20survival%20horror%20theme&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: 'thriller',
    description: '平凡的高中校园，在某天下午突然爆发了丧尸病毒。一群性格迥异的学生被困在校园内，必须在物资匮乏的情况下团结协作，寻找逃出生天的方法。友情、背叛、牺牲，末日之下的人性考验。',
    rating: 4.5,
    views: 8500000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 爆发', updatedAt: '2026-08-02' },
      { id: 2, title: '第2话 被困', updatedAt: '2026-08-03' },
      { id: 3, title: '第3话 求生之路', updatedAt: '2026-08-04' },
      { id: 4, title: '第4话 信任危机', updatedAt: '2026-08-05' },
    ],
    tags: ['悬疑', '丧尸', '校园', '生存'],
    updatedAt: '2026-08-05',
    createdAt: '2025-11-01',
  },
  {
    id: 6,
    slug: 'chong-sheng-zhi-ba-quan-zong-cai',
    title: '重生之霸拳总裁',
    author: '韩志浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylish%20Korean%20webtoon%20illustration%20of%20a%20confident%20man%20in%20a%20luxury%20suit%20with%20his%20fists%20wrapped%20in%20bandages%2C%20corporate%20office%20background%20with%20city%20skyline%20view%2C%20manhwa%20art%20style%2C%20action%20business%20theme%2C%20dramatic%20lighting&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: 'action',
    description: '前拳击冠军重生为财阀继承人，这一次他不再只是靠拳头说话。拳王的战斗本能加上总裁的商业头脑，他在商界掀起了一场又一场腥风血雨。但宿敌的出现让他明白——有些恩怨，只有拳头才能了结。',
    rating: 4.4,
    views: 7200000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 拳王之死', updatedAt: '2026-08-01' },
      { id: 2, title: '第2话 重生财阀', updatedAt: '2026-08-04' },
    ],
    tags: ['动作', '重生', '商战', '格斗'],
    updatedAt: '2026-08-04',
    createdAt: '2026-01-05',
  },
  {
    id: 7,
    slug: 'chong-wu-jing-ling-de-mi-mi',
    title: '宠物精灵的秘密',
    author: '尹恩惠',
    cover: 'https://readdy.ai/api/search-image?query=A%20whimsical%20Korean%20webtoon%20illustration%20of%20a%20girl%20surrounded%20by%20cute%20magical%20creatures%20in%20a%20lush%20garden%2C%20sparkling%20fairy%20dust%2C%20soft%20pastel%20warm%20colors%2C%20manhwa%20art%20style%2C%20fantasy%20slice%20of%20life%20theme&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: 'fantasy',
    description: '小女孩苏琳搬进外婆的老房子后，在后院发现了一扇通往精灵世界的小门。那里的精灵们有着不为人知的秘密——他们曾经是人类最亲密的伙伴。随着人类世界的遗忘，精灵的世界正在逐渐消亡，苏琳成了拯救它们的最后希望。',
    rating: 4.3,
    views: 5400000,
    status: '已完结',
    chapters: [
      { id: 1, title: '第1话 外婆的花园', updatedAt: '2026-06-10' },
      { id: 2, title: '第2话 会说话的花朵', updatedAt: '2026-06-20' },
    ],
    tags: ['奇幻', '治愈', '宠物', '冒险'],
    updatedAt: '2026-06-20',
    createdAt: '2025-05-15',
  },
  {
    id: 8,
    slug: 'gao-xiao-tian-tuan',
    title: '搞笑天团',
    author: '张东民',
    cover: 'https://readdy.ai/api/search-image?query=A%20hilarious%20Korean%20webtoon%20illustration%20of%20four%20friends%20making%20exaggerated%20funny%20faces%20at%20a%20school%20desk%2C%20bright%20and%20colorful%20art%20style%2C%20manhwa%20comedy%20theme%2C%20expressive%20characters%2C%20warm%20playful%20atmosphere&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: 'comedy',
    description: '四个性格迥异的高中生组成了校园里最搞笑的团体。学霸、体育健将、艺术天才和社交达人——听起来很强，实际上每天不是在出糗就是在出糗的路上。他们的日常就是一部行走的喜剧片。',
    rating: 4.1,
    views: 6800000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 成立', updatedAt: '2026-08-01' },
      { id: 2, title: '第2话 第一次出糗', updatedAt: '2026-08-03' },
      { id: 3, title: '第3话 运动会大作战', updatedAt: '2026-08-05' },
    ],
    tags: ['搞笑', '校园', '日常', '友情'],
    updatedAt: '2026-08-05',
    createdAt: '2026-02-28',
  },
  {
    id: 9,
    slug: 'hong-chen-lian',
    title: '红尘恋',
    author: '姜素拉',
    cover: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20Korean%20webtoon%20illustration%20of%20a%20couple%20in%20traditional%20hanbok%20standing%20under%20a%20cherry%20blossom%20tree%20at%20sunset%2C%20historical%20romance%20theme%2C%20manhwa%20art%20style%20with%20delicate%20linework%2C%20warm%20golden%20hour%20lighting&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: 'drama',
    description: '朝鲜时代，两班贵族之女与平民画师之间跨越阶级的凄美爱情故事。在动荡的时代背景下，两人用画笔与书信传递心意，谱写了一段流传后世的红尘恋歌。',
    rating: 4.9,
    views: 15200000,
    status: '已完结',
    chapters: [
      { id: 1, title: '第1话 初遇', updatedAt: '2026-05-01' },
      { id: 2, title: '第2话 桃花信笺', updatedAt: '2026-05-15' },
    ],
    tags: ['剧情', '历史', '恋爱', '古风'],
    updatedAt: '2026-05-15',
    createdAt: '2024-11-01',
  },
  {
    id: 10,
    slug: 'shang-ban-zu-de-sheng-cun-fa-ze',
    title: '上班族的生存法则',
    author: '吴贤宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20relatable%20Korean%20webtoon%20illustration%20of%20a%20tired%20office%20worker%20slumping%20at%20his%20desk%20surrounded%20by%20papers%20and%20coffee%20cups%2C%20warm%20office%20lighting%2C%20manhwa%20art%20style%2C%20slice%20of%20life%20workplace%20comedy%20theme&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: 'daily',
    description: '刚毕业的菜鸟金在宇进入了一家普通公司，每天都在职场丛林中艰难求生。奇葩上司、阴阳同事、无休止的加班——这就是韩国上班族的真实写照。好在办公室里的美女前辈总是在暗中帮他，一段温馨搞笑的职场故事。',
    rating: 4.2,
    views: 6300000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 入职第一天', updatedAt: '2026-08-02' },
      { id: 2, title: '第2话 第一次加班', updatedAt: '2026-08-04' },
    ],
    tags: ['日常', '职场', '搞笑', '治愈'],
    updatedAt: '2026-08-04',
    createdAt: '2026-03-10',
  },
  {
    id: 11,
    slug: 'kong-bu-xue-yuan',
    title: '恐怖学院',
    author: '申东烨',
    cover: 'https://readdy.ai/api/search-image?query=A%20creepy%20Korean%20webtoon%20illustration%20of%20an%20abandoned%20school%20classroom%20with%20a%20ghostly%20figure%20in%20the%20corridor%2C%20dark%20atmospheric%20horror%2C%20manhwa%20art%20style%20with%20heavy%20ink%20shadows%2C%20psychological%20thriller%20theme%2C%20cold%20moonlight%20through%20broken%20windows&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: 'horror',
    description: '位于郊区的一所废弃学院，每到午夜就会传出诡异的钢琴声。五个胆大的学生组成探险小组，决定揭开学院的秘密。但他们不知道的是，有些秘密一旦被揭开，就再也没有回头路可走。',
    rating: 4.6,
    views: 9100000,
    status: '已完结',
    chapters: [
      { id: 1, title: '第1话 传闻', updatedAt: '2026-07-10' },
      { id: 2, title: '第2话 夜闯禁地', updatedAt: '2026-07-17' },
    ],
    tags: ['恐怖', '悬疑', '校园', '灵异'],
    updatedAt: '2026-07-17',
    createdAt: '2025-10-30',
  },
  {
    id: 12,
    slug: 'qiu-ji-zhi-lian',
    title: '球技之恋',
    author: '崔始源',
    cover: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Korean%20webtoon%20illustration%20of%20a%20female%20basketball%20player%20dribbling%20on%20court%20with%20a%20male%20player%20watching%20admiringly%20from%20the%20sideline%2C%20sports%20romance%20theme%2C%20manhwa%20art%20style%2C%20dynamic%20action%2C%20warm%20gymnasium%20lighting&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: 'school',
    description: '篮球部的王牌选手朴智浩，在一次校际比赛中被对手学校的女篮队长打败。不服输的他开始暗中观察她的训练，却不知不觉被她的魅力所吸引。一场从球场开始的青春恋爱故事。',
    rating: 4.0,
    views: 4800000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 惨败', updatedAt: '2026-08-01' },
      { id: 2, title: '第2话 暗中观察', updatedAt: '2026-08-04' },
    ],
    tags: ['校园', '恋爱', '运动', '篮球'],
    updatedAt: '2026-08-04',
    createdAt: '2026-04-20',
  },
  {
    id: 13,
    slug: 'tian-shi-zhi-ge',
    title: '天使之歌',
    author: '金泰妍',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20illustration%20of%20a%20girl%20singing%20on%20stage%20with%20angel%20wings%20of%20light%20behind%20her%2C%20concert%20atmosphere%20with%20sparkling%20stage%20lights%2C%20manhwa%20art%20style%2C%20musical%20fantasy%20theme%2C%20warm%20spotlight&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    category: 'drama',
    description: '失去声音的天才歌手与一位落魄作曲家相遇，两人在音乐中找到了彼此的救赎。当她重新找回声音的那一刻，整个舞台都为她而闪耀。一段关于音乐、梦想与爱的动人故事。',
    rating: 4.7,
    views: 11300000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 失声', updatedAt: '2026-08-02' },
      { id: 2, title: '第2话 那个男人', updatedAt: '2026-08-04' },
      { id: 3, title: '第3话 第一次合奏', updatedAt: '2026-08-05' },
    ],
    tags: ['剧情', '音乐', '励志', '恋爱'],
    updatedAt: '2026-08-05',
    createdAt: '2025-12-01',
  },
  {
    id: 14,
    slug: 'mo-fa-shao-nu-yu-e-long',
    title: '魔法少女与恶龙',
    author: '宋慧乔',
    cover: 'https://readdy.ai/api/search-image?query=A%20magical%20Korean%20webtoon%20illustration%20of%20a%20magical%20girl%20in%20a%20colorful%20dress%20riding%20a%20friendly%20dragon%20through%20the%20clouds%2C%20fantasy%20adventure%20theme%2C%20manhwa%20art%20style%2C%20vibrant%20warm%20colors%2C%20whimsical%20atmosphere&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    category: 'fantasy',
    description: '在魔法王国中，每个魔法少女成年后都要驯服一条属于自己的龙。但主角小米的龙不仅不会喷火，还特别爱撒娇卖萌。当黑暗势力威胁王国时，这条"废柴"龙却展现了惊人的力量——因为它是一条被封印的上古神龙。',
    rating: 4.5,
    views: 8900000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 驯龙仪式', updatedAt: '2026-08-01' },
      { id: 2, title: '第2话 最弱的龙', updatedAt: '2026-08-05' },
    ],
    tags: ['奇幻', '冒险', '魔法', '龙'],
    updatedAt: '2026-08-05',
    createdAt: '2026-01-15',
  },
  {
    id: 15,
    slug: 'du-shen',
    title: '赌神',
    author: '刘在石',
    cover: 'https://readdy.ai/api/search-image?query=A%20tense%20Korean%20webtoon%20illustration%20of%20a%20man%20in%20a%20dark%20suit%20holding%20playing%20cards%20at%20a%20luxury%20casino%20table%2C%20dramatic%20overhead%20lighting%2C%20manhwa%20art%20style%2C%20gambling%20thriller%20theme%2C%20intense%20atmosphere&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    category: 'thriller',
    description: '曾是韩国地下赌场传奇的韩正宇，因一场阴谋失去了一切。隐姓埋名五年后，他以全新的身份重返赌坛，誓要揪出幕后黑手。每一局牌都是生死较量，每一个对手都可能是敌人。',
    rating: 4.3,
    views: 7700000,
    status: '连载中',
    chapters: [
      { id: 1, title: '第1话 最后一局', updatedAt: '2026-08-03' },
      { id: 2, title: '第2话 五年后', updatedAt: '2026-08-05' },
    ],
    tags: ['悬疑', '赌博', '复仇', '都市'],
    updatedAt: '2026-08-05',
    createdAt: '2026-02-01',
  },
  {
    id: 16,
    slug: 'she-jian-shang-de-ai-qing',
    title: '舌尖上的爱情',
    author: '金喜爱',
    cover: 'https://readdy.ai/api/search-image?query=A%20delicious%20Korean%20webtoon%20illustration%20of%20a%20couple%20cooking%20together%20in%20a%20cozy%20kitchen%2C%20steaming%20food%20on%20the%20table%2C%20romantic%20culinary%20theme%2C%20manhwa%20art%20style%2C%20warm%20intimate%20lighting%2C%20food%20love%20story&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    category: 'romance',
    description: '美食评论家与街头小吃摊主之间的浪漫故事。她吃遍米其林，却被他的一碗辣炒年糕征服了味蕾和心。两个来自完全不同世界的人，在美食的牵引下，找到了彼此。',
    rating: 4.4,
    views: 6100000,
    status: '已完结',
    chapters: [
      { id: 1, title: '第1话 路边摊', updatedAt: '2026-07-05' },
      { id: 2, title: '第2话 辣炒年糕', updatedAt: '2026-07-20' },
    ],
    tags: ['恋爱', '美食', '治愈', '都市'],
    updatedAt: '2026-07-20',
    createdAt: '2025-07-10',
  },
];